/**
 * Case, for a reader's own locale.
 *
 * `Intl` answers a weekday or a month in the locale's SENTENCE case — Polish writes „poniedziałek"
 * and „wrzesień" lower-case — which is correct inside a sentence and wrong as the standing label of
 * a form field or as a picker's heading. So the capital is applied where the string is USED rather
 * than asked for from a formatter that has no option for it.
 *
 * `toLocaleUpperCase` rather than `toUpperCase`: Turkish dotless i is the standard counter-example,
 * and the locale is always to hand at these call sites.
 *
 * No React, no DOM, no query hook, no i18next.
 */

/** The first character upper-cased for `locale`, the rest untouched. */
export function capitaliseFirst(value: string, locale: string): string {
  const [first, ...rest] = [...value];
  return first === undefined ? value : first.toLocaleUpperCase(locale) + rest.join('');
}
